/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect } from "react";
import { refreshAuth } from "../../app/auth/authThunk";
import { logout } from "../../app/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import useVerifyToken from "./useVerifyToken";
import setAuthToken from "../../utils/setAuthToken";
import { chatWSDisconnecting } from "../../app/chat/chatSlice";

import { setAvailable } from "../../app/userState/userStateSlice";
import Layout from "../../layouts/layout-authorized";
import { dashboardWSDisconnecting } from "../../app/dashboard/dashboardSlice";
import DMSPlugin from "../dms-plugin";
import VEPlugin from "../ve-plugin";

interface IProps {
    children: JSX.Element;
    showSidebar?: boolean;
}
interface IToken {
    token: string,
    refreshToken: string
}
const unauthorizedRoutes = [
    "/",
    "/dashboard",
    "/chat",
    "/chat/:chatId",
    "/profile",
    "/profile/security",
    "/profile/change-password",
    "/profile/edit",
];

const adminRoles = ["TOWR", "TMGR", "TADM"];


const PrivateRoute: FC<IProps> = ({ children, showSidebar = true }) => {
    const { isAuthenticated, routes, user } = useAppSelector(
        (state) => state.auth
    );
    const dispatch = useAppDispatch();
    const navigateTo = useNavigate();
    const location = useLocation();
    const accessToken = localStorage.getItem("access-token") ?? "";
    const refreshToken = localStorage.getItem("refresh-token") ?? "";

    useEffect(() => {
        if (!isAuthenticated && accessToken) {
            setAuthToken({
                token: accessToken,
                refreshToken,
            });

            dispatch(refreshAuth(accessToken)).catch((e) => console.log(e));
        }
    }, []);

    const { response, error } = useVerifyToken(accessToken ?? "", location, isAuthenticated);

    useEffect(() => {
        if (error) {
            dispatch(chatWSDisconnecting());
            dispatch(dashboardWSDisconnecting());
            dispatch(setAvailable(false));
            dispatch(logout());
            navigateTo(`signin`);
        } else if (response) {
            const { data } = response;
            const newtoken = (data as IToken)
            setAuthToken({ token: newtoken.token, refreshToken: newtoken.refreshToken });
            dispatch(refreshAuth(newtoken.token)).catch((e) => console.log(e));

        }

    }, [response]);

    useEffect(() => {
        if (!accessToken) {
            navigateTo("/signin", { replace: true });
        }
    }, [accessToken]);

    useEffect(() => {
        console.log("turning off dashboard WS>>", !location.pathname.includes('dashboard'))
        if (!location.pathname.includes('dashboard')) dispatch(dashboardWSDisconnecting());
    }, [location.pathname]);
    useEffect(() => {
        if (!isAuthenticated) return;

        const currentPath = location.pathname.split("?")[0];

        const isWhiteListed =
            unauthorizedRoutes.findIndex((r) => r === currentPath) > -1 ||
            unauthorizedRoutes
                .filter(
                    (r) => r.lastIndexOf("/") === currentPath.lastIndexOf("/")
                )
                .filter((r) => r.indexOf(":") > -1).length > 0;

        const isAdmin =
            adminRoles.findIndex((r) => r === user?.cmRoleName) > -1;

        if (isWhiteListed || isAdmin) return;

        const isAuthorized =
            routes.filter((r) => r.route.indexOf(currentPath) > -1).length >
            0 ||
            routes
                .filter(
                    (r) =>
                        r.route.lastIndexOf("/") ===
                        currentPath.lastIndexOf("/")
                )
                .filter((r) => r.route.indexOf(":") > -1).length > 0;

        if (!isAuthorized) navigateTo("/error-403", { replace: true });
    }, [location, isAuthenticated]);

    return <><DMSPlugin></DMSPlugin>
        <VEPlugin></VEPlugin><Layout showSidebar={showSidebar}>{children}</Layout></>;
};

export default PrivateRoute;
